export const LIVE_NOTIFICATION_PREFERENCES_ENTITY_TYPE='live_notification_preferences';

export const DEFAULT_LIVE_NOTIFICATION_PREFERENCES=Object.freeze({
  enabled:false,
  stageEndEnabled:true,
  stageEndLeadMinutes:5,
  temperatureIntervalMinutes:null
});

const ALLOWED_TEMPERATURE_INTERVALS=new Set([15,30,60]);

function bool(value,fallback){
  return typeof value==='boolean'?value:fallback;
}

function lead(value){
  const number=Number(value);
  if(!Number.isInteger(number)||number<0||number>30){
    throw new TypeError('stageEndLeadMinutes must be an integer between 0 and 30');
  }
  return number;
}

function temperatureInterval(value){
  if(value==null||value==='')return null;
  const number=Number(value);
  if(!ALLOWED_TEMPERATURE_INTERVALS.has(number)){
    throw new TypeError('temperatureIntervalMinutes must be one of 15, 30, 60 or null');
  }
  return number;
}

export function normaliseLiveNotificationPreferences(value={}){
  const source=value&&typeof value==='object'?value:{};
  return Object.freeze({
    enabled:bool(source.enabled,DEFAULT_LIVE_NOTIFICATION_PREFERENCES.enabled),
    stageEndEnabled:bool(source.stageEndEnabled,DEFAULT_LIVE_NOTIFICATION_PREFERENCES.stageEndEnabled),
    stageEndLeadMinutes:lead(source.stageEndLeadMinutes??DEFAULT_LIVE_NOTIFICATION_PREFERENCES.stageEndLeadMinutes),
    temperatureIntervalMinutes:temperatureInterval(
      source.temperatureIntervalMinutes??DEFAULT_LIVE_NOTIFICATION_PREFERENCES.temperatureIntervalMinutes
    )
  });
}

export function createLiveNotificationPreferenceStore({
  repository,
  userId,
  now=()=>new Date().toISOString()
}={}){
  if(!repository?.get||!repository?.put)throw new TypeError('repository with get/put is required');
  const owner=String(userId||'').trim();
  if(!owner)throw new TypeError('userId is required');

  async function get(){
    const row=await repository.get(LIVE_NOTIFICATION_PREFERENCES_ENTITY_TYPE,owner);
    if(!row)return DEFAULT_LIVE_NOTIFICATION_PREFERENCES;
    if(row.userId!==owner)throw new Error('LIVE_NOTIFICATION_PREFERENCES_OWNER_MISMATCH');
    return normaliseLiveNotificationPreferences(row);
  }

  async function save(changes={}){
    const current=await get();
    const value=normaliseLiveNotificationPreferences({...current,...changes});
    await repository.put(LIVE_NOTIFICATION_PREFERENCES_ENTITY_TYPE,{
      id:owner,
      userId:owner,
      ...value,
      updatedAt:now()
    });
    return value;
  }

  async function disable(){
    return save({enabled:false});
  }

  return Object.freeze({get,save,disable});
}
